export const INVITE_RECIPIENT_MODAL_LABELS = {
  modalTitle: 'Edit third-party portal recipients',
  body: 'Updating the recipient list will grant or revoke access to every questionnaire shared with this third party across all assessments.',
  addRecipients: 'Add recipients',
  existingRecipients: 'Existing recipients',
  newRecipientsInvite: 'New recipients will get an invite.',
  businessOwnerCc: 'Business owner in CC',
  businessOwnerCcDescription: (thirdPartyName: string) =>
    `Gets a copy of every email to ${thirdPartyName}, without portal access.`,
  buttons: {
    cancel: 'Cancel',
    save: 'Save',
  },
} as const
